import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=a6c15210&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=ts&"
export * from "./MenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=a6c15210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c15210",
  null
  
)

export default component.exports